import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ge_GE from './translations/ge.json';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  ge: {
    translation: ge_GE,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'ge',
    keySeparator: true,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
